import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewAll: {
		defaultMessage: 'View all dashboards',
		id: 'atlassian-navigation.dashboards.menu.footer.view-all',
		description: '"View all dashboards" menu item',
	},
});
